module.exports = __webpack_public_path__ + "static/media/star_2_gray.8c656d55.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stars/star_2_gray.svg
// module id = 333
// module chunks = 0